"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var CoreContext = (0, react_1.createContext)({});
exports.default = CoreContext;
